import React, { useEffect, useRef, useState } from "react";

import CreativeDialog from "./CreativeDialog";
import { useDispatch, useSelector } from "react-redux";
import {
  getPendingCreatives,
  getApprovedCreatives,
  approveCreative,
  getRejectedCreatives,
  getCreatives,
} from "../../redux/slices/apiSlice";
import { FaCheck, FaRegEdit } from "react-icons/fa";
import { RxCross1 } from "react-icons/rx";
import { showAlert } from "../../utils";
import {
  creativeApproveAndRejectRoles,
  creativeClientRejectApproveAccess,
  creativeUploadRoles,
  getAllRequestsByAccountName,
} from "./CreativeConstants";

export const ActionDropdown = ({
  requestId = null,
  status = "",
  onclose,
  disableActions = false,
  currentTab = "",
  accountName,
  userRole,
}) => {
  const [open, setOpen] = useState(false);
  const [isApproved, setIsApproved] = useState("");
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);

  const user = sessionStorage.getItem("user");

  const userId = user ? JSON.parse(user)._id : null;
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const approveAlert = async (id) => {
    const value = await showAlert({
      title: <span className="text-[18px]"></span>,
      text: "Are you sure you want to approve this request?",
      cancelButtonText: "Cancel",
      confirmButtonText: "Confirm",
    });
    if (value) {
      setIsApproved("Approved");
      dispatch(
        approveCreative({
          payload: {
            userID: userId,
            rejected: false,
            creativeId: requestId,
            isApproved: true,
            status: "Approved", 
            userEmail: user?.email || user?.user_name || "",
          },
        })
      ).then(() => {
        if (getAllRequestsByAccountName.includes(userRole)) {
          dispatch(
            getCreatives({
              payload: { userId: userId, account_name: accountName },
            })
          );
        } else {
          dispatch(
            getCreatives({
              payload: { userId: userId },
            })
          );
        }
      });
      setOpen(false);
    }
  };
  return (
    <div className="relative" ref={dropdownRef}>
      <CreativeDialog
        title={"Rejection Reason"}
        isOpen={rejectDialogOpen}
        onClose={() => {
          setRejectDialogOpen(false);
        }}
        content={
          <div className="w-full flex flex-col gap-2 ">
            <textarea
              className="w-full border outline-none  p-2"
              rows={10}
              value={rejectReason}
              onChange={(e) => {
                e.preventDefault();
                setRejectReason(e.target.value);
              }}
              placeholder="Type reason here"
            />
            <div className="flex gap-2 items-center">
              <button
                className="text-gray-400 p-2 border-[0.5px]  hover:bg-gray-100 rounded bg-gray-200"
                onClick={() => {
                  setRejectDialogOpen(false);
                }}
              >
                Cancel
              </button>
              <button
                disabled={rejectReason === ""}
                className="p-2 bg-blue-500 text-white rounded hover:bg-blue-400"
                onClick={() => {
                  setIsApproved("Rejected");
                  dispatch(
                    approveCreative({
                      payload: {
                        userID: userId,
                        creativeId: requestId,
                        isApproved: false,
                        status: "Rejected", 
                        reason: rejectReason,
                        rejected: true,
                        userEmail: user?.email || user?.user_name || "",
                      },
                    })
                  ).then(() => {
                    if (getAllRequestsByAccountName.includes(userRole)) {
                      dispatch(
                        getCreatives({
                          payload: {
                            userId: userId,
                            account_name: accountName,
                          },
                        })
                      );
                    } else {
                      dispatch(
                        getCreatives({
                          payload: { userId: userId },
                        })
                      );
                    }
                  });
                  setOpen(false);
                  setRejectDialogOpen(false);
                  onclose();
                }}
              >
                Confirm
              </button>
            </div>
          </div>
        }
      />
      {
        creativeClientRejectApproveAccess.includes(userRole) ? 
<button
        onClick={() => setOpen(!open)}
        disabled={
          status === "Pending" &&
          creativeApproveAndRejectRoles.includes(userRole)
            ? false
            : creativeClientRejectApproveAccess.includes(userRole)
            ? false
            : true
        }
        className=" rounded-md "
      >
        {status === "Approved" ? (
          <div className="flex gap-2 items-center">
            {" "}
            {/* <FaCheck className="text-blue-500 text-base" /> */}
            Approved
          </div>
        ) : status === "Rejected" ? (
          <div className="flex gap-2 items-center">
            {/* <RxCross1 className="font-bold text-red-500 text-xl" /> */}
            Rejected
          </div>
        ) : !creativeUploadRoles.includes(userRole) ? (
          <FaRegEdit className="text-lg" />
        ) : (
          "Pending"
        )}
      </button>
        : "N/A"
      }
      
      {open && (
        <div className="absolute right-0 mt-1 z-10 bg-white border rounded-md shadow-lg w-28">
          {(status === "Rejected" || status === "Pending") && (
            <button
              className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              onClick={approveAlert}
            >
              Approve
            </button>
          )}
          {(status === "Approved" || status === "Pending") && (
            <button
              className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              onClick={() => setRejectDialogOpen(true)}
            >
              Reject
            </button>
          )}
        </div>
      )}
    </div>
  );
};
